const translations = {
  pt: {
    paymentsOut: {
      title: "Contas a Pagar",
      buttons: {
        createButton: "Criar",
        modalConfirmButton: "Cadastrar"
      },
      screenTexts: {
        paid: "Pago",
        toPay: "A Pagar",
        notInformed: "Não Informado",
        createCategory: "Criar Categoria",
        noCategoryOption: "Sem Categoria",
        createCostCenter: "Criar Centro de Custo",
        noCostCenterOption: "Sem Centro de Custo",
        clientPlaceholder: "Busque aqui"
      },
      tableData: {
        description: "Descrição",
        status: "Status",
        value: "Valor",
        person: "Fornecedor",
        category: "Categoria",
        costCenter: "Centro de Custo",
        dueDate: "Data de Vencimento",
        paymentMethod: "Forma de Pagamento",
        actions: "Ações"
      },
      modalFields: {
        description: "Descrição",
        status: {
          title: "Situação",
          toPay: "A Pagar",
          paid: "Pago",
          canceled: "Cancelado"
        },
        cost_type: {
          title: "Tipo de Custo",
          variable: "Custo Variável",
          fixed: "Custo Fixo"
        },
        value: "Valor",
        show: "Exibir",
        person: "Fornecedor",
        category: "Categoria",
        costCenter: "Centro de Custo",
        dueDate: "Data de Vencimento",
        paymentMethod: "Método de Pagamento",
        startCreatedDate: "Início do Intervalo de Criação",
        endCreatedDate: "Fim do Intervalo de Criação",
        startDueDate: "Início do Intervalo do Vencimento",
        endDueDate: "Fim do Intervalo do Vencimento"
      },
      actions: {
        confirm: {
          labelText: "Pagar Conta",
          originalValueText: "Valor Original",
          confirmValue: "Valor a Pagar",
          confirmDiscount: "Desconto",
          confirmPenalty: "Multa",
          confirmTax: "Taxa"
        },
        edit: {
          labelText: "Editar Conta",
          editValue: "Novo Valor"
        },
        cancel: {
          labelText: "Cancelar Conta",
          cancelText: "Cancelar",
          cancelButton: "Sim"
        },
        details: {
          labelText: "Ver Detalhes"
        }
      }
    },
    paymentsIn: {
      title: "Contas a Receber",
      buttons: {
        createButton: "Criar",
        modalConfirmButton: "Cadastrar"
      },
      screenTexts: {
        received: "Recebido",
        toReceive: "A Receber",
        canceled: "Cancelado",
        notInformed: "Não Informado",
        createCategory: "Criar Categoria",
        noCategoryOption: "Sem Categoria",
        createCostCenter: "Criar Centro de Custo",
        noCostCenterOption: "Sem Centro de Custo",
        clientPlaceholder: "Busque aqui"
      },
      tableData: {
        description: "Descrição",
        status: "Status",
        value: "Valor",
        person: "Cliente",
        category: "Categoria",
        costCenter: "Centro de Custo",
        dueDate: "Data de Vencimento",
        paymentMethod: "Forma de Pagamento",
        actions: "Ações"
      },
      modalFields: {
        description: "Descrição",
        status: {
          title: "Situação",
          toReceive: "A Receber",
          received: "Recebido",
          canceled: "Cancelado"
        },
        cost_type: {
          title: "Tipo de Custo",
          variable: "Custo Variável",
          fixed: "Custo Fixo"
        },
        repeat: {
          title: "Repetir",
          quantity: "Quantidade",
          range: "Período"
        },
        value: "Valor",
        show: "Exibir",
        person: "Cliente",
        category: "Categoria",
        costCenter: "Centro de Custo",
        dueDate: "Data de Vencimento",
        paymentMethod: "Método de Pagamento",
        startCreatedDate: "Início do Intervalo de Criação",
        endCreatedDate: "Fim do Intervalo de Criação",
        startDueDate: "Início do Intervalo de Vencimento",
        endDueDate: "Fim do Intervalo de Vencimento"
      },
      actions: {
        confirm: {
          labelText: "Receber Conta",
          originalValueText: "Valor Original",
          confirmValue: "Valor a Receber",
          confirmDiscount: "Desconto",
          confirmPenalty: "Multa",
          confirmTax: "Taxa"
        },
        edit: {
          labelText: "Editar Conta",
          editValue: "Novo Valor"
        },
        cancel: {
          labelText: "Cancelar Conta",
          cancelText: "Cancelar",
          cancelButton: "Sim"
        },
        details: {
          labelText: "Ver Detalhes"
        }
      }
    }
  },

  en: {
    paymentsOut: {
      title: "Accounts Payable",
      buttons: {
        createButton: "Create",
        modalConfirmButton: "Register"
      },
      screenTexts: {
        paid: "Paid",
        toPay: "To Pay",
        notInformed: "Not Informed",
        createCategory: "Create Category",
        noCategoryOption: "No Category",
        createCostCenter: "Create Cost Center",
        noCostCenterOption: "No Cost Center",
        clientPlaceholder: "Search here"
      },
      tableData: {
        description: "Description",
        status: "Status",
        value: "Value",
        person: "Supplier",
        category: "Category",
        costCenter: "Cost Center",
        dueDate: "Due Date",
        paymentMethod: "Payment Method",
        actions: "Actions"
      },
      modalFields: {
        description: "Description",
        status: {
          title: "Situation",
          toPay: "To Pay",
          paid: "Paid",
          canceled: "Canceled"
        },
        cost_type: {
          title: "Cost Type",
          variable: "Variable Cost",
          fixed: "Fixed Cost"
        },
        value: "Value",
        show: "Show",
        person: "Supplier",
        category: "Category",
        costCenter: "Cost Center",
        dueDate: "Due Date",
        paymentMethod: "Payment Method",
        startCreatedDate: "Start of Creation Interval",
        endCreatedDate: "End of Creation Interval",
        startDueDate: "Start of Due Interval",
        endDueDate: "End of Due Interval"
      },
      actions: {
        confirm: {
          labelText: "Pay Bill",
          originalValueText: "Original Value",
          confirmValue: "Value to Pay",
          confirmDiscount: "Discount",
          confirmPenalty: "Penalty",
          confirmTax: "Fee"
        },
        edit: {
          labelText: "Edit Bill",
          editValue: "New Value"
        },
        cancel: {
          labelText: "Cancel Bill",
          cancelText: "Cancel",
          cancelButton: "Yes"
        },
        details: {
          labelText: "View Details"
        }
      }
    },
    paymentsIn: {
      title: "Accounts Receivable",
      buttons: {
        createButton: "Create",
        modalConfirmButton: "Register"
      },
      screenTexts: {
        received: "Received",
        toReceive: "To Receive",
        canceled: "Canceled",
        notInformed: "Not Informed",
        createCategory: "Create Category",
        noCategoryOption: "No Category",
        createCostCenter: "Create Cost Center",
        noCostCenterOption: "No Cost Center",
        clientPlaceholder: "Search here"
      },
      tableData: {
        description: "Description",
        status: "Status",
        value: "Value",
        person: "Client",
        category: "Category",
        costCenter: "Cost Center",
        dueDate: "Due Date",
        paymentMethod: "Payment Method",
        actions: "Actions"
      },
      modalFields: {
        description: "Description",
        status: {
          title: "Situation",
          toReceive: "To Receive",
          received: "Received",
          canceled: "Canceled"
        },
        cost_type: {
          title: "Cost Type",
          variable: "Variable Cost",
          fixed: "Fixed Cost"
        },
        repeat: {
          title: "Repeat",
          quantity: "Quantity",
          range: "Period"
        },
        value: "Value",
        show: "Show",
        person: "Client",
        category: "Category",
        costCenter: "Cost Center",
        dueDate: "Due Date",
        paymentMethod: "Payment Method",
        startCreatedDate: "Start of Creation Interval",
        endCreatedDate: "End of Creation Interval",
        startDueDate: "Start of Due Interval",
        endDueDate: "End of Due Interval"
      },
      actions: {
        confirm: {
          labelText: "Receive Bill",
          originalValueText: "Original Value",
          confirmValue: "Value to Receive",
          confirmDiscount: "Discount",
          confirmPenalty: "Penalty",
          confirmTax: "Fee"
        },
        edit: {
          labelText: "Edit Bill",
          editValue: "New Value"
        },
        cancel: {
          labelText: "Cancel Bill",
          cancelText: "Cancel",
          cancelButton: "Yes"
        },
        details: {
          labelText: "View Details"
        }
      }
    }
  },

  es: {
    paymentsOut: {
      title: "Cuentas por Pagar",
      buttons: {
        createButton: "Crear",
        modalConfirmButton: "Registrar"
      },
      screenTexts: {
        paid: "Pagado",
        toPay: "A Pagar",
        notInformed: "No Informado",
        createCategory: "Crear Categoría",
        noCategoryOption: "Sin Categoría",
        createCostCenter: "Crear Centro de Costo",
        noCostCenterOption: "Sin Centro de Costo",
        clientPlaceholder: "Buscar aquí"
      },
      tableData: {
        description: "Descripción",
        status: "Estado",
        value: "Valor",
        person: "Proveedor",
        category: "Categoría",
        costCenter: "Centro de Costo",
        dueDate: "Fecha de Vencimiento",
        paymentMethod: "Forma de Pago",
        actions: "Acciones"
      },
      modalFields: {
        description: "Descripción",
        status: {
          title: "Situación",
          toPay: "A Pagar",
          paid: "Pagado",
          canceled: "Cancelado"
        },
        cost_type: {
          title: "Tipo de Costo",
          variable: "Costo Variable",
          fixed: "Costo Fijo"
        },
        value: "Valor",
        show: "Mostrar",
        person: "Proveedor",
        category: "Categoría",
        costCenter: "Centro de Costo",
        dueDate: "Fecha de Vencimiento",
        paymentMethod: "Método de Pago",
        startCreatedDate: "Inicio del Intervalo de Creación",
        endCreatedDate: "Fin del Intervalo de Creación",
        startDueDate: "Inicio del Intervalo de Vencimiento",
        endDueDate: "Fin del Intervalo de Vencimiento"
      },
      actions: {
        confirm: {
          labelText: "Pagar Factura",
          originalValueText: "Valor Original",
          confirmValue: "Valor a Pagar",
          confirmDiscount: "Descuento",
          confirmPenalty: "Multa",
          confirmTax: "Tasa"
        },
        edit: {
          labelText: "Editar Factura",
          editValue: "Nuevo Valor"
        },
        cancel: {
          labelText: "Cancelar Factura",
          cancelText: "Cancelar",
          cancelButton: "Sí"
        },
        details: {
          labelText: "Ver Detalles"
        }
      }
    },
    paymentsIn: {
      title: "Cuentas por Cobrar",
      buttons: {
        createButton: "Crear",
        modalConfirmButton: "Registrar"
      },
      screenTexts: {
        received: "Recibido",
        toReceive: "A Cobrar",
        canceled: "Cancelado",
        notInformed: "No Informado",
        createCategory: "Crear Categoría",
        noCategoryOption: "Sin Categoría",
        createCostCenter: "Crear Centro de Costo",
        noCostCenterOption: "Sin Centro de Costo",
        clientPlaceholder: "Buscar aquí"
      },
      tableData: {
        description: "Descripción",
        status: "Estado",
        value: "Valor",
        person: "Cliente",
        category: "Categoría",
        costCenter: "Centro de Costo",
        dueDate: "Fecha de Vencimiento",
        paymentMethod: "Forma de Pago",
        actions: "Acciones"
      },
      modalFields: {
        description: "Descripción",
        status: {
          title: "Situación",
          toReceive: "A Cobrar",
          received: "Recibido",
          canceled: "Cancelado"
        },
        cost_type: {
          title: "Tipo de Costo",
          variable: "Costo Variable",
          fixed: "Costo Fijo"
        },
        repeat: {
          title: "Repetir",
          quantity: "Cantidad",
          range: "Periodo"
        },
        value: "Valor",
        show: "Mostrar",
        person: "Cliente",
        category: "Categoría",
        costCenter: "Centro de Costo",
        dueDate: "Fecha de Vencimiento",
        paymentMethod: "Método de Pago",
        startCreatedDate: "Inicio del Intervalo de Creación",
        endCreatedDate: "Fin del Intervalo de Creación",
        startDueDate: "Inicio del Intervalo de Vencimiento",
        endDueDate: "Fin del Intervalo de Vencimiento"
      },
      actions: {
        confirm: {
          labelText: "Cobrar Factura",
          originalValueText: "Valor Original",
          confirmValue: "Valor a Cobrar",
          confirmDiscount: "Descuento",
          confirmPenalty: "Multa",
          confirmTax: "Tasa"
        },
        edit: {
          labelText: "Editar Factura",
          editValue: "Nuevo Valor"
        },
        cancel: {
          labelText: "Cancelar Factura",
          cancelText: "Cancelar",
          cancelButton: "Sí"
        },
        details: {
          labelText: "Ver Detalles"
        }
      }
    }
  }
}


export default translations


// WEBPACK FOOTER //
// ./src/views/AppViews/Financial/languages.jsx